import { render, staticRenderFns } from "./CatalogDetail.vue?vue&type=template&id=0f8d4f42&"
import script from "./CatalogDetail.vue?vue&type=script&lang=js&"
export * from "./CatalogDetail.vue?vue&type=script&lang=js&"
import style0 from "./CatalogDetail.vue?vue&type=style&index=0&id=0f8d4f42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports